document.addEventListener("DOMContentLoaded", function () {
    const planSelect = document.querySelector('select[name="options[ Choose your plan]"]');

    // Function to update the second select box based on the first one
    function updateRecurpaySelection() {
        const recurpaySelect = document.querySelector('select[name="recurpay-input"]'); // Fetch again in case it's rendered later

        if (!recurpaySelect) return; // If still not available, exit

        const selectedPlan = planSelect.value.trim(); // Get selected plan

        for (let option of recurpaySelect.options) {
            if (option.getAttribute("data-plan-name") === selectedPlan) {
                option.selected = true; // Select matching option
                break; // Stop loop once correct option is found
            }
        }

        // Trigger change event to ensure any dependent logic executes
        recurpaySelect.dispatchEvent(new Event('change'));

        clearInterval(waitForRecurpaySelect); // Stop checking once found
    }

    // Set interval to check if recurpay-input select box is available
    const waitForRecurpaySelect = setInterval(() => {
        if (document.querySelector('select[name="recurpay-input"]')) {
            updateRecurpaySelection(); // Execute function when available
        }
    }, 500); // Check every 500ms

    // Listen for change event on the first select box
    if (planSelect) {
        planSelect.addEventListener("change", updateRecurpaySelection);
    }
});
